import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Media, Container, Row, Col } from "reactstrap";
import OpenFileLink from "../Components/OpenFileLink";
import { joinCss } from "../helpers/utils";
import LinesEllipsis from "react-lines-ellipsis";

import classes from "./Specification.module.scss";

import edition from "../images/editionSmall.png";
import fix from "../images/fixSmall.png";

class specification extends Component {
  constructor(props) {
    super(props);

    this.openSpecification = this.openSpecification.bind(this);
  }
  openSpecification = () => {
    this.props.history.push("/AllSpecifications/" + this.props.data.id);
  };
  render() {
    return (
      <div onClick={this.openSpecification}>
        <Container
          //key={this.props.data.id}
          className={joinCss(this.props.componentClass, classes.cube)}
        >
          <Row>
            <Col>
              <LinesEllipsis
                className={classes.chapterName}
                maxLine="2"
                text={this.props.data.name}
              />
            </Col>
          </Row>
          <Row className={classes.chapterNumbers}>
            <Col
              sm="5"
              className={joinCss(classes.editionNumber, classes.numbers)}
            >
              <Media
                object
                className={classes.specificationCubeLogo}
                src={edition}
                alt="מספר מהדורות"
              />
              {this.props.data.numberOfEditions}
            </Col>
            <Col sm="5" className={classes.numbers}>
              <Media
                object
                className={classes.specificationCubeLogo}
                src={fix}
                alt="מספר דפי תיקון"
              />
              {this.props.data.numberOfFixes}
            </Col>
            <Col sm="2" xs="0" />
          </Row>
          <Row className={classes.publishAt}>
            <Col xs="6">תאריך עידכון אחרון:</Col>
            <Col xs="6">{this.props.data.publishAt}</Col>
          </Row>
          <Row className={classes.fixes}>
            <Col sm="5" className={classes.linkCol}>
              <OpenFileLink
                localClass={classes.pdfLink}
                contant={this.props.data.editions[0].pdfName}
                id={this.props.data.editions[0].id}
                numOfLines="2"
                textLocalClass={classes.pdfName}
              />
            </Col>
            {this.props.data.editions[0].fixes.map((fix, index) =>
              index == 0 ? (
                <Col key={"Link" + fix.id} sm="5" className={classes.linkCol}>
                  <OpenFileLink
                    localClass={classes.pdfLink}
                    contant={fix.pdfName}
                    id={fix.id}
                    numOfLines="2"
                    textLocalClass={classes.pdfName}
                  />
                </Col>
              ) : index === 1 ? (
                <Col key={"More" + fix.id} sm="2" className={classes.numberCol}>
                  <span className={classes.numberSpan}>
                    +{this.props.data.editions[0].fixes.length - 1}
                  </span>
                </Col>
              ) : (
                ""
              )
            )}
          </Row>
        </Container>
        {/* </Link> */}
      </div>
    );
  }
}

export default withRouter(specification);
